import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";

// app config if the default config to use for every organization that are only on .app domain

const config: Partial<AppDomainConfig> = {
  allowFeatureStylerPinToRight: true,
  domains: ["app"],
  font: "18px  monospace, serif",
  iconCategories: [],
  iconSet: ["app", "mui-rounded"],
  iconsSearch: true,
  id: "app",
  name: "App",
  settings: {
    stops_api_prefagencies: "db,sbb",
  },
  slug: "mapsetapp",
  ...colors,
};

export default config;
